export default __webpack_public_path__ + "static/media/centro_odontologico_recoleta.2601ba21.jpg";